import nextApi from "./next-api";

const getOurServices = () => {
  return nextApi.get("cms/our-services");
};

const createOurServices = (data) => {
  return nextApi.post("cms/our-services", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateOurServices = (id, data) => {
  return nextApi.put(`cms/our-services?id=${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteOurServices = (id) => {
  return nextApi.delete(`cms/our-services?id=${id}`);
};

const OurServices = {
  getOurServices,
  createOurServices,
  updateOurServices,
  deleteOurServices,
};

export default OurServices;
